import * as MutationTypes from "../mutation_types"
import { State, AuthHeaders, MedicineQuestionUsage, QuickSurveyAnswer } from "../store_types"
import { callMedicineQuestionAnalyticsAPI } from "../../api/medicine_question_analytics"
import { AxiosResponseHeaders } from "axios"

const getDefaultState  = () => {
  return {
    medicineQuestionUsageAllCount: 0,
    medicineQuestionPregnantUsages : null,
    medicineQuestionAfterChildbirthUsages : null,
    medicineQuestionQuickSurveys : [],
  }
}

const medicineQuestionAnalytics = {
  state: () => getDefaultState(),

  getters: {
    medicineQuestionUsageAllCount (state : State) {
      return state.medicineQuestionUsageAllCount
    },
    medicineQuestionPregnantUsages (state : State) {
      return state.medicineQuestionPregnantUsages
    },
    medicineQuestionAfterChildbirthUsages (state : State) {
      return state.medicineQuestionAfterChildbirthUsages
    },
    medicineQuestionQuickSurveys (state : State) {
      return state.medicineQuestionQuickSurveys
    },
  },

  actions: {
    fetchMedicineQuestionAnalytics({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders | number | MedicineQuestionUsage | Array<QuickSurveyAnswer>) => void, getters: { [key: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        callMedicineQuestionAnalyticsAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedMedicineQuestionAnalyticsDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, medicineQuestionUsageAllCount: number, medicineQuestionPregnantUsages: MedicineQuestionUsage, medicineQuestionAfterChildbirthUsages: MedicineQuestionUsage, medicineQuestionQuickSurveys: Array<QuickSurveyAnswer>) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_MEDICINE_QUESTION_USAGE_ALL_COUNT, medicineQuestionUsageAllCount)
            commit(MutationTypes.ASSIGN_MEDICINE_QUESTION_PREGNANT_USAGES, medicineQuestionPregnantUsages)
            commit(MutationTypes.ASSIGN_MEDICINE_QUESTION_AFTER_CHILDBIRTH_USAGES, medicineQuestionAfterChildbirthUsages)
            commit(MutationTypes.ASSIGN_MEDICINE_QUESTION_QUICK_SURVEYS, medicineQuestionQuickSurveys)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    resetCorporationsState ({ commit }: { commit: (mutationType:string) => void }) {
      commit(MutationTypes.RESET_MEDICINE_QUESTION_ANALYTICS_STATE)
    }
  },

  mutations: {
    [MutationTypes.ASSIGN_MEDICINE_QUESTION_USAGE_ALL_COUNT](state: State, medicineQuestionUsageAllCount: number) {
      state.medicineQuestionUsageAllCount = medicineQuestionUsageAllCount
    },
    [MutationTypes.ASSIGN_MEDICINE_QUESTION_PREGNANT_USAGES](state: State, medicineQuestionPregnantUsages: MedicineQuestionUsage) {
      state.medicineQuestionPregnantUsages = medicineQuestionPregnantUsages
    },
    [MutationTypes.ASSIGN_MEDICINE_QUESTION_AFTER_CHILDBIRTH_USAGES](state: State, medicineQuestionAfterChildbirthUsages: MedicineQuestionUsage) {
      state.medicineQuestionAfterChildbirthUsages = medicineQuestionAfterChildbirthUsages
    },
    [MutationTypes.ASSIGN_MEDICINE_QUESTION_QUICK_SURVEYS](state: State, medicineQuestionQuickSurveys: Array<QuickSurveyAnswer>) {
      state.medicineQuestionQuickSurveys = medicineQuestionQuickSurveys
    },
    [MutationTypes.RESET_MEDICINE_QUESTION_ANALYTICS_STATE](state: State) {
      Object.assign(state, getDefaultState())
    },
  }
}

export default medicineQuestionAnalytics
